import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@mui/styles";
import { Box, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { deleteLeaveGroup, getAllLeaveGroupByVendorId } from "../../../../../actions/leave";
import ButtonBlue from "../../../shared/general/ButtonBlue";
import AddIcon from "@mui/icons-material/Add";

import AccordionRow from "./components/accordionRow";
import LeaveForm from "./components/leaveForm";
import DialogConfirmDelete from "../../../shared/general/DialogConfirmDelete";
import { openNotificationAlert } from "../../../../../actions/notificationAlert";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: "30px",
    "& .MuiTypography-h6": {
      fontSize: "1.5rem",
    },
  },
  paper: {
    padding: theme.spacing(1),
    borderRadius: "20px",
    boxShadow: "rgb(90 114 123 / 11%) 0px 7px 30px 0px",
  },
}));

const StyledHeadingPage = styled("div")({
  marginBottom: 16,
});

const LeaveManage = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  const { result: userProfile } = useSelector((state) => state.userProfile);

  const [leaveGroupList, setLeaveGroupList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  
  const [drawerConfig, setDrawerConfig] = useState({
    isOpen: false,
    isEdit: false,
    data: null,
  });

  const [dialogDeleteConfig, setDialogDeleteConfig] = useState({
    isOpen: false,
    data: {},
  })

  const fetchingAllLeaveGroup = () => {
    setIsLoading(true);
    dispatch(getAllLeaveGroupByVendorId(userProfile.idVendor)).then(res => {
      if(res && res.status === 200){
        setLeaveGroupList(res.data);
      }
    }).finally(() => {
      setIsLoading(false);
    })
  }

  useEffect(() => {
    if(userProfile){
      fetchingAllLeaveGroup();
    }
  }, [userProfile])

  const handleCloseDrawer = () => {
    setDrawerConfig((prev) => ({
      ...prev,
      isOpen: false,
    }));
  };

  const handleOpenDialogDelete = (data) => {
    setDialogDeleteConfig({
      isOpen: true,
      data: data,
    })
  }

  const handleCloseDialogDelete = () => {
    setDialogDeleteConfig(prev => ({
      isOpen: false,
    }))
  }

  const handleConfirmDelete = async () => {
    if(dialogDeleteConfig.data.idLeaveGroup){
      const result = await dispatch(deleteLeaveGroup(dialogDeleteConfig.data.idLeaveGroup));
      if(result && result.status === 200) {
        handleCloseDialogDelete();
        dispatch(openNotificationAlert({
          type: "success",
          message: t("DataSaveSuccessful"),
        }));
        fetchingAllLeaveGroup();
      } else {
        dispatch(openNotificationAlert({
          type: "error",
          message: t("AnErrorOccurred")
        }));
      }
    }
  }
  
  return (
    <div className={classes.root}>
      {!drawerConfig.isOpen && (
        <>
          <StyledHeadingPage>
            <Grid container justifyContent="space-between">
              <Grid item>
                <Typography variant="h6">{t("LeaveDay")}</Typography>
              </Grid>
              <Grid item>
                <ButtonBlue
                  variant={"contained"}
                  startIcon={<AddIcon />}
                  onClick={() => {
                    setDrawerConfig((prev) => ({
                      ...prev,
                      isOpen: true,
                      isEdit: false,
                    }));
                  }}
                >
                  {t("AddLeaveDay")}
                </ButtonBlue>
              </Grid>
            </Grid>
          </StyledHeadingPage>

          <Box>
            {isLoading? (
              <Typography fontSize="24px" textAlign="center" color="text.secondary">{t("LoadingData")}</Typography>
            ): leaveGroupList.length === 0? (
              <Typography fontSize="24px" textAlign="center" color="text.secondary">{t("NoData")}</Typography>
            ): leaveGroupList.map((item, index) => (
              <AccordionRow
                data={item}
                key={`accordion_${item.idLeaveGroup}`}
                setDrawerConfig={setDrawerConfig}
                handleOpenDialogDelete={handleOpenDialogDelete}
              />
            ))}
          </Box>
        </>
      )}

      {drawerConfig.isOpen && (
        <LeaveForm
          drawerConfig={drawerConfig}
          onClose={handleCloseDrawer}
          fetchingAllLeaveGroup={fetchingAllLeaveGroup}
        />
      )}

      {dialogDeleteConfig.isOpen && (
        <DialogConfirmDelete
          open={dialogDeleteConfig.isOpen}
          handleClose={handleCloseDialogDelete}
          text={dialogDeleteConfig.data.leaveGroupName}
          handleDelete={handleConfirmDelete}
        />
      )}
    </div>
  );
}

export default LeaveManage;